import { Component, OnInit } from '@angular/core';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupSetupService } from '../shared/providers/signup-setup.service';
import { AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers'; //Added for accessories button

declare var ENV_PORTAL:any;//Added for accessories button

@Component({
  selector: 'app-confirm-signup-setup',
  templateUrl: './confirm-signup-setup.component.html',
  styleUrls: ['./confirm-signup-setup.component.scss'],
  providers: [SignupSetupService,
              AdobeAnalyticsService//Added for accessories button
             ]
})
export class ConfirmSignupSetupComponent implements OnInit {
  
  confirmAccounts: any;
  enrolledData: any;
  prodcode: string;
  abm: boolean = false;
  ztp: boolean = false;
  kme: boolean = false;
  toggleTooltip;
  signedupData: any;
  fanListData: any;
  availableFansFlag: boolean = false;
  isABMFE: boolean = false;
  public isPremier: boolean = false;//Added for accessories button
  // public selectedFAN:any;
  // ddo: any;

  constructor(private route: ActivatedRoute, private stepIndicatorService: StepIndicatorService, 
    private router: Router, private signupSetupService: SignupSetupService,
    private adobeAnalyticsService: AdobeAnalyticsService, private utilityService:UtilityService) { //Added for accessories button
    
  }

  ngOnInit() {
    this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicatorService.setVisibility(true);
    this.prodcode = sessionStorage.getItem('prodcode');
    if (this.prodcode === 'Apple Business Manager') {
      this.abm = true;
    } else if (this.prodcode === 'Samsung Knox Mobile Enrollment (KME)') {
      this.kme = true;
    } else {
      this.ztp = true;
    }
    this.confirmAccounts = this.route.snapshot.data.pageData.signupsetupconfirm;
    this.signedupData = JSON.parse(sessionStorage.getItem('signedupData'));
    this.enrolledData = JSON.parse(sessionStorage.getItem('enrolledFans'));
    this.fanListData = JSON.parse(sessionStorage.getItem('signupFanList'));
    this.availableFansFlag = JSON.parse(sessionStorage.getItem('availableFansFlag'));
    if(sessionStorage.getItem('feFlag') == "true"){
      this.enrolledData.emmAccountId = "Pending";  
      this.isABMFE = true;   
    }else{
      this.isABMFE = false;
    }
    
    sessionStorage.setItem('feFlag', 'false');
    // Added for accessories button
    if (ENV_PORTAL==='sapmp'||ENV_PORTAL==='dmpadmin')
    {
        this.isPremier=true;
    } 
  }

  gotoDashboard() {
    sessionStorage.setItem('cacheFlag', 'true');
    sessionStorage.setItem('feFlag', 'false');
    this.router.navigate(['/dashboard']);
  }

  gotoProdSel() {
    //sessionStorage.setItem('cacheFlag', 'true');
    sessionStorage.setItem('selectedProd', 'applebusinessmanager');
    sessionStorage.setItem('reenrollappleflag', 'true');
    sessionStorage.setItem('feFlag', 'false');
    this.router.navigate(['/productselection']);
  }
   //Added for accessories button
  gotoAccesories() {
    let url= this.utilityService.getEnvConfig().accessoriesLink;
    //to get UTM parameters
    const utmSource = 'DMP device inventory'; 
    const utmMedium = 'button'; 
    const utmCampaign ='device accessory showcase'; 
    
    //to get FAN number
    // console.log('selectedFAN: ', this.signedupData[0].fanId);
    // const FANsignedUp=this.signedupData[0].fanId;
    this.adobeAnalyticsService.createClickProperties('Enrollment Confirmation Purchase accessories', 'body', '/business/shop/shop_cru_home.jsp');
    
    // Append all parameters to the URL
    const trackedUrl = `${url}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
    
    // Navigate to the tracked URL
    window.open(trackedUrl, '_blank');
  }

  naviateToPage(pageName: string) {
    this.router.navigate([`/${pageName}`], {state: {pageUpdate: true}});
  }
    
}

